import { render, staticRenderFns } from "./USTArrow.vue?vue&type=template&id=490766b7&scoped=true&"
import script from "./USTArrow.vue?vue&type=script&lang=js&"
export * from "./USTArrow.vue?vue&type=script&lang=js&"
import style0 from "./USTArrow.vue?vue&type=style&index=0&id=490766b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490766b7",
  null
  
)

export default component.exports